import { HttpClient, HttpClientRequest, HttpClientResponse } from '@effect/platform';
import { RewardsData } from '@silo/data';
import { Address, makeAddressSync, ProtocolKey } from '@silo/types';
import { useSiloWeb3 } from '@silo/web3';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Effect, pipe } from 'effect';

export const rewardsDataKey = 'rewardsData';

type RewardsDataKey = [key: typeof rewardsDataKey, protocolKey: ProtocolKey, user: Address];

export function useQueryRewardsData() {
  const { protocolInstance, account } = useSiloWeb3();

  const user = account ? makeAddressSync(account) : undefined;

  return useQuery({
    queryKey: [rewardsDataKey, protocolInstance!, user!],
    queryFn: queryRewardsData,
    enabled: !!protocolInstance && !!user,
  });
}

const queryRewardsData: QueryFunction<RewardsData, RewardsDataKey> = async ({ queryKey: [_, protocolKey, user] }) => {
  const result = await pipe(
    HttpClientRequest.get('/api/rewards'),
    HttpClientRequest.appendUrlParams({ protocol: protocolKey, user }),
    HttpClient.fetchOk,
    Effect.andThen(HttpClientResponse.schemaBodyJson(RewardsData)),
    Effect.scoped,
    Effect.runPromise
  );

  return result;
};
